import { useRef, ReactElement } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'react-router-dom';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap, Tooltip } from "@mui/material";
import { useSetCustomAccordionState } from 'redux/accordion/accordion';
import styles from './styles.module.scss';
import ROUTERS_PATHS from "../../../consts/router-paths";
import {useSetCustomTableState} from "../../../redux/customTable/customTableSlice";

type ListItemCustomProps = {
  className: string;
  item: {
    path: string;
    label: string;
    Icon: any;
    redLabel: boolean;
    isPersonalItem?: boolean;
  };
};

const ListItemCustom = (props: ListItemCustomProps) => {
  const { className, item } = props;
  const { Icon } = item;
  const customTableService = useSetCustomTableState();
  const customAccordion = useSetCustomAccordionState();

  const resetAdminTableType = (path: string) => { // reset dashboard data table type when click admin/home in left menu
    if (path === ROUTERS_PATHS.ADMIN_DASHBOARD) {
      customTableService.setCustomTableField({adminTableType: 'category'})
    } else {
      customAccordion.setAccordionField({ itemAccordion: '', itemAccordionTree: '', selectItemAccordion: {} });
    }
    customTableService.setCustomTableField({sortDirection: 'desc', sortField: undefined, pageIndex: 0, pageSize: 15, 
    generalSearchField: undefined, filterFields: undefined, checkColumns: {}, checkedValues: [], filterCols: []})
  }

  return (
    <ListItem disablePadding className={`${className} ${(item.isPersonalItem && styles.personal) || ''}`}>
      <ListItemButton className={styles.listItemButton} onClick={() => {resetAdminTableType(item.path)}}>
        <Link to={item.path} className={styles.routerLink}>
          <ListItemIcon className={styles.listItemIcon}>
            <Icon />
          </ListItemIcon>
         <ListItemText primary={item.label} className={item.redLabel ? styles.listItemTextRed : styles.listItemText} />
        </Link>
      </ListItemButton>
    </ListItem>
  );
};

export default ListItemCustom;
